export const racePlayers = [
    { name: "Yuri", id: 1331867 },
    { name: "Dinho", id: 560630 },
    { name: "Moraes", id: 560635 },
    { name: "Carmona", id: 1085576 },
    { name: "Luva", id: 1600084 },
    { name: "Caiox", id: 1634429 },
    { name: "Xakaall", id: 1633328 },
    { name: "Piuzinho", id: 1632900 },
    { name: "Snopey", id: 1632854 },
    { name: "Gabepeixe", id: 1570494 },
    { name: "Acada", id: 1570487 },
    { name: "Raia", id: 1021083 },
    { name: "Papionline", id: 1755105 },
    { name: "N2online", id: 1141125 },
    { name: "Carnavalonline", id: 956314 },
    { name: "Bponline", id: 1260723 }
];

export const rankImages = {
    1: '/static/images/1.png',
    2: '/static/images/2.png',
    3: '/static/images/3.png',
};